import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_FILE_TYPES, 
    ADD_NEW_FILE_TYPE, 
    UPDATE_FILE_TYPE, 
    DELETE_FILE_TYPE 
} from "./actionTypes";

import {
    getFileTypesSuccess,
    getFileTypesFail,
    addFileTypeSuccess,
    addFileTypeFail,
    updateFileTypeSuccess,
    updateFileTypeFail,
    deleteFileTypeSuccess,
    deleteFileTypeFail,
   
} from "./actions"

import {
    getFileTypes,
    addNewFileType,
    updateFileType,
    deleteFileType,
   
} from "helpers/file-types/file_types_backend_helper";
import { toast } from "react-toastify";

function* fetchFileTypes() {
    try {
        const response = yield call(getFileTypes)
        yield put(getFileTypesSuccess(response))
    } catch (error) {
        yield put(getFileTypesFail(error))
    }
}

function* onAddNewFileType({ payload }) {
    try {

        console.log("PAYLOAD: ", payload);
        const response = yield call(addNewFileType, payload)

        console.log("RESPONSE:", response);
        yield put(addFileTypeSuccess(response.fileType))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addFileTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdateFileType({ payload: data }) {
    try {
        const response = yield call(updateFileType, data)
        yield put(updateFileTypeSuccess(response))
        toast.success("Branch  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateFileTypeFail(error))
        toast.error("Branch  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdateFileType({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateFileType, payload)
        yield put(updateFileTypeSuccess(response.fileType))
        toast.success(response.data.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateFileTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteFileType({ payload: data }) {

    try {
        const response = yield call(deleteFileType, data)
        yield put(deleteFileTypeSuccess(response.fileTypeId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteFileTypeFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* fileTypeSaga() {
    yield takeEvery(GET_FILE_TYPES, fetchFileTypes)
    yield takeEvery(ADD_NEW_FILE_TYPE, onAddNewFileType)
    yield takeEvery(UPDATE_FILE_TYPE, onUpdateFileType)
    yield takeEvery(DELETE_FILE_TYPE, onDeleteFileType)
}

export default fileTypeSaga;